export const TOP_DOMAINS_DISPLAYED = 7;
export const OTHERS_NODE_ID = "others";
export const OTHERS_NODE_REGEX = new RegExp(`-${OTHERS_NODE_ID}$`);
export const DOMAIN_TOOLTIP_FILTER_BUTTON_ID = "filter-domain-button";
